import { domain } from "../../Auth/Config";
const freespinGameIframeUrl = domain + "/wp-json/freespin/v1/game";
const getNotificationEndpoint =  domain + "/wp-json/freespin/v1/getTransactionNotification";
export { freespinGameIframeUrl, getNotificationEndpoint };
